import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import UserLogin from "../components/public/UserLogin";
import { verify } from "../modules/user/redux/action";
import privateRoutes from "../routes/privateRoutes";
import publicRoutes from "../routes/publicRoutes";
import sessionRoutes from "../routes/sessionRoutes";
import PrivateLayout from "./private";
import PublicLayout from "./public";
import NotFound from "./public/NotFound";




class Template extends Component {
  componentWillMount() {
    this.props.verify();
  }

  render() {
    const user = this.props.user;
    // user.logged = true
    return (
      <BrowserRouter>
        <Switch>
          {_.map(publicRoutes, (route, key) => {
            const { component, path } = route;
            return (
              <Route
                exact
                path={path}
                key={key}
                render={route =>
                  user.logged ? (
                    <Redirect to="/app" />
                  ) : (
                    <PublicLayout
                      Component={component}
                      route={route}
                      user={user}
                    />
                  )
                }
              />
            );
          })}

          {_.map(privateRoutes, (route, key) => {
            const { component, path } = route;
            return (
              <Route
                exact
                path={path}
                key={key}
                render={route =>
                  user.logged ? (
                    <PrivateLayout component={component} route={route} />
                  ) : (
                    <PublicLayout
                      Component={UserLogin}
                      route={route}
                      user={user}
                    />
                  )
                }
              />
            );
          })}

          {_.map(sessionRoutes, (route, key) => {
            const { component, path } = route;
            return (
              <Route
                exact
                path={path}
                key={key}
                render={route =>
                  user.logged ? (
                    <Redirect to="/app" />
                  ) : (
                    <PublicLayout
                      component={component}
                      route={route}
                      user={user}
                    />
                  )
                }
              />
            );
          })}

          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    );
  }
}

function mapStateToProps(state, props) {
  return { user: state.user };
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  { verify }
)(Template);



// WEBPACK FOOTER //
// ./src/template/index.js